<app-select-user *ngIf="users?.length" [users$]="users$" >
</app-select-user>

<app-profile *ngIf="selectedUser" [user$]="selectedUser$">
</app-profile>